import Vue from "vue";
import * as Sentry from "@sentry/vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/styles/tokens.css";
import "./assets/styles/base.css";

Vue.config.productionTip = false;

/**
 * Error reporting only — every sampling rate is 0, so no traces, sessions or replays are
 * sent. That is deliberate for a service that handles identity documents: a session
 * replay would capture the user's face and signature.
 */
Sentry.init({
  Vue,
  dsn: "https://a503ea2f3823ab71e063d49a2c33a2d4@sentry.hamisystem.ir/9",
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
